import React, { Component } from 'react'
import { Carousel, Row, Col, Icon, Divider } from 'antd'
import {PieChart, Pie, Cell, Tooltip, Legend } from 'recharts'

let data = [{name: 'Leave Taken', value: 2400}, {name: 'Unused Leaves', value: 4567}];

const COLORS = ['#0088FE','#FFBB28'];
const data_le = [
    'Racing car sprays burning fuel into crowd.',
    'Japanese princess to wed commoner.',
    'Australian walks 100km after outback crash.',
    'Man charged over missing wedding girl.',
    'Los Angeles battles huge wildfires.',
];

export default class Summary extends Component {

    constructor( props ){
        super( props );

        this.state = {
            data: [],
            annual_summary: [],
            sick_summary: [],
            compassionate_summary: [],
            wedding_summary: [],
            emergency_summary: []
        }

    }

    componentWillReceiveProps( nextProps ) {

        if( nextProps.data.length !== 0 ){

            if( nextProps.data.annual_data[0] ){

                let len = nextProps.data.annual_data[0].summary.length;

                let total_leave_taken = Math.abs( nextProps.data.annual_data[0].summary[len-2].total_leave_taken );
                let unused_leaves = Math.abs( nextProps.data.annual_data[0].summary[len-2].unused_leaves );
    
                if( unused_leaves < 0 ){
                    unused_leaves = 0;
                }

                this.setState({
                    annual_summary: [
                        { name: 'Leave Taken', value: total_leave_taken }, 
                        { name: 'Unused Leaves', value: unused_leaves }
                    ]
                });
    
            }
    
            if( nextProps.data.sick_data[0] ){

                let len = nextProps.data.sick_data[0].summary.length;
    
                let total_leave_taken = Math.floor( nextProps.data.sick_data[0].summary[len-2].total_leave_taken );
                let unused_leaves = Math.floor( nextProps.data.sick_data[0].summary[len-2].unused_leaves );
                
                if( unused_leaves < 0 ){
                    unused_leaves = 0;
                }
    
                this.setState({
                    sick_summary: [
                        { name: 'Leave Taken', value: total_leave_taken }, 
                        { name: 'Unused Leaves', value: unused_leaves }
                    ]
                });
    
            }
    
            if( nextProps.data.compassionate_data[0] ){

                let len = nextProps.data.compassionate_data[0].summary.length;
    
                let total_leave_taken = Math.floor( nextProps.data.compassionate_data[0].summary[len-2].total_leave_taken );
                let unused_leaves = Math.floor( nextProps.data.compassionate_data[0].summary[len-2].unused_leaves );

                if( unused_leaves < 0 ){
                    unused_leaves = 0;
                }
    
                this.setState({
                    compassionate_summary: [
                        { name: 'Leave Taken', value: total_leave_taken }, 
                        { name: 'Unused Leaves', value: unused_leaves }
                    ]
                });
    
            }
    
            if( nextProps.data.wedding_data[0] ){

                let len = nextProps.data.wedding_data[0].summary.length;
    
                let total_leave_taken = Math.floor( nextProps.data.wedding_data[0].summary[len-2].total_leave_taken );
                let unused_leaves = Math.floor( nextProps.data.wedding_data[0].summary[len-2].unused_leaves );

                if( unused_leaves < 0 ){
                    unused_leaves = 0;
                }
    
                this.setState({
                    wedding_summary: [
                        { name: 'Leave Taken', value: total_leave_taken }, 
                        { name: 'Unused Leaves', value: unused_leaves }
                    ]
                });
    
            }
    
            if( nextProps.data.emergency_data[0] ){
                
                let len = nextProps.data.emergency_data[0].summary.length;
    
                let total_leave_taken = Math.floor( nextProps.data.emergency_data[0].summary[len-2].total_leave_taken );
                let unused_leaves = Math.floor( nextProps.data.emergency_data[0].summary[len-2].unused_leaves );

                if( unused_leaves < 0 ){
                    unused_leaves = 0;
                }
    
                this.setState({
                    emergency_summary: [
                        { name: 'Leave Taken', value: total_leave_taken }, 
                        { name: 'Unused Leaves', value: unused_leaves }
                    ]
                });
    
            }

        }

    }
    
    render() {
        return (
            <div>
                <Row>
                    <Col span={24} style={{marginBottom: '40px'}}>
                        <h2>
                            <Icon type="file-done" />
                            &nbsp; Leave Summary
                        </h2>
                    </Col>
                </Row>
                
                <Row>
                    <Col span={ 24 }>
                        <Carousel>
                            <div>
                                <Row gutter={14}>
                                    <Col span={8}>
                                        <span className="summary_header">Annual Leave Summary</span>
                                        <PieChart width={200} height={250}>
                                            <Pie data={ this.state.annual_summary } cx={100} cy={100} 
                                                innerRadius={50} outerRadius={70} fill="#82ca9d"
                                                label>
                                                {
                                                    this.state.annual_summary.map((entry, index) => <Cell key={index} fill={COLORS[index % COLORS.length]}/>)
                                                }
                                            </Pie>
                                            <Legend />
                                            <Tooltip/>
                                        </PieChart>
                                    </Col>
                                    <Col span={8}>
                                        <span className="summary_header">Sick Leave Summary</span>
                                        <PieChart width={200} height={250}>
                                            <Pie data={ this.state.sick_summary } cx={100} cy={100} 
                                                innerRadius={50} outerRadius={70} fill="#82ca9d"
                                                label>
                                                {
                                                    this.state.sick_summary.map((entry, index) => <Cell key={index} fill={COLORS[index % COLORS.length]}/>)
                                                }
                                            </Pie>
                                            <Legend />
                                            <Tooltip/>
                                        </PieChart>
                                    </Col>
                                    <Col span={8}>
                                        <span className="summary_header">Compassionate Leave Summary</span>
                                        <PieChart width={200} height={250}>
                                            <Pie data={ this.state.compassionate_summary } cx={100} cy={100} 
                                                innerRadius={50} outerRadius={70} fill="#82ca9d"
                                                label>
                                                {
                                                    this.state.compassionate_summary.map((entry, index) => <Cell key={index} fill={COLORS[index % COLORS.length]}/>)
                                                }
                                            </Pie>
                                            <Legend />
                                            <Tooltip/>
                                        </PieChart>
                                    </Col>
                                </Row>
                            </div>
                            <div>
                                <Row>
                                    <Col span={8}>
                                        <span className="summary_header">Wedding Leave Summary</span>
                                        <PieChart width={200} height={250}>
                                            <Pie data={ this.state.wedding_summary } cx={100} cy={100} 
                                                innerRadius={50} outerRadius={70} fill="#82ca9d"
                                                label>
                                                {
                                                    this.state.wedding_summary.map((entry, index) => <Cell key={index} fill={COLORS[index % COLORS.length]}/>)
                                                }
                                            </Pie>
                                            <Legend />
                                            <Tooltip/>
                                        </PieChart>
                                    </Col>
                                    <Col span={8}>
                                        <span className="summary_header">Emergency Leave Summary</span>
                                        <PieChart width={200} height={250}>
                                            <Pie data={ this.state.emergency_summary } cx={100} cy={100} 
                                                innerRadius={50} outerRadius={70} fill="#82ca9d"
                                                label>
                                                {
                                                    this.state.emergency_summary.map((entry, index) => <Cell key={index} fill={COLORS[index % COLORS.length]}/>)
                                                }
                                            </Pie>
                                            <Legend />
                                            <Tooltip/>
                                        </PieChart>
                                    </Col>
                                </Row>
                            </div>
                        </Carousel>
                    </Col>
                </Row>

                <Row>
                    <Col span={24} style={{height: '20px'}}></Col>
                </Row>


            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/pages/profile/childs/summary.js